import { defineStore } from "pinia";
import { ref } from "vue";
import jQuery from "jquery";

type Status = {
  preventHide: boolean;
};

type Texts = {
  title: string;
  content: string;
  cancelLabel: string;
  confirmLabel: string;
};

type TextsPayload = {
  TITLE: string;
  CONTENT: string;
  CANCEL_LABEL: string;
  CONFIRM_LABEL: string;
};

type Functions = {
  cancelFunction: (() => void) | null;
  confirmFunction: (() => void) | null;
};

type ModalData = {
  status: Status;
  texts: Texts;
  functions: Functions;
};

type PayloadModal = {
  status?: Status;
  texts: Texts | TextsPayload;
  functions: Partial<Functions>;
};

const defaultCancelFunction = () => null;

const getInitialStatus = (): Status => ({
  preventHide: false,
});

const getInitialTexts = (): Texts => ({
  title: "",
  content: "",
  cancelLabel: "",
  confirmLabel: "",
});

const getInitialFunctions = (): Functions => ({
  cancelFunction: null,
  confirmFunction: null,
});

const normalizeTexts = (texts: Record<string, string>): Texts => ({
  title: texts.title ?? texts.TITLE ?? "",
  content: texts.content ?? texts.CONTENT ?? "",
  cancelLabel: texts.cancelLabel ?? texts.CANCEL_LABEL ?? "",
  confirmLabel: texts.confirmLabel ?? texts.CONFIRM_LABEL ?? "",
});

const useModalStore = defineStore("modal", () => {
  const modalData = ref<ModalData>({
    status: getInitialStatus(),
    functions: getInitialFunctions(),
    texts: getInitialTexts(),
  });

  const setModal = (payload: PayloadModal) => {
    if (payload.status?.preventHide) {
      modalData.value.status.preventHide = true;
    }

    modalData.value.texts = normalizeTexts(payload.texts);

    modalData.value.functions = {
      cancelFunction: payload.functions.cancelFunction ?? defaultCancelFunction,
      confirmFunction: payload.functions.confirmFunction ?? null,
    };

    (jQuery("#shared-modal") as any).modal("show");
  };

  const resetModalStatus = () => {
    (jQuery("#shared-modal") as any).modal("hide");
    modalData.value = {
      status: getInitialStatus(),
      functions: getInitialFunctions(),
      texts: getInitialTexts(),
    };
  };

  return {
    modalData,
    setModal,
    resetModalStatus,
  };
});

export default useModalStore;
